(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.document = document.getElementsByTagName('body')[0];
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.updateHeaderHeight = debounce(this.setMainContentMargin.bind(this), 100);

      this.setMainContentMargin();

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', this.updateHeaderHeight);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.updateHeaderHeight);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      let boundCompare = this.headerBounds.bottom;

      if (document.body.classList.contains('index')) {
        boundCompare = 200;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > boundCompare) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > boundCompare) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      // this.setMainContentMargin();

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-sticky');
      document.body.classList.add('header-sticky--enabled');
      this.closeMenuDisclosure();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      document.body.classList.add('header-sticky--enabled');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.body.classList.remove('header-sticky--enabled');
      this.closeMenuDisclosure();
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('menu-disclosure');
      this.disclosures.forEach(disclosure => typeof disclosure.close === 'function' && disclosure.close());
    }

    setMainContentMargin() {
      var mainContent = document.getElementById('MainContent'),
          headerHeight = this.offsetHeight,
          announcement = document.getElementById('announcementSwiper'),
          announcementHeight = 0;

      if(announcement){
        announcementHeight = announcement.offsetHeight;
        this.header.classList.add('shopify-section-announcements-enabled');
        this.header.style.setProperty('--announcementBar-height', `${ -announcementHeight }px`);
        document.querySelector('#MainContent') && document.querySelector('#MainContent').classList.add('shopify-section-announcements-enabled');
      }

      document.body.style.setProperty('--announcementBar-height', `${announcementHeight}px`);
      document.body.style.setProperty('--header-height', `${headerHeight}px`);

      if (mainContent) {
        mainContent.setAttribute('data-header-height', headerHeight);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-johnson-hartig"]) return;
  try {
    
  class JohnsonHartig extends HTMLElement {
    constructor() {
      super();
      this.offsetSrc = this.querySelector('[data-offset-src]').firstElementChild;
      this.handleOffset = this.defineOffset.bind(this);
    }

    connectedCallback() {
      window.addEventListener('resize', this.handleOffset);

      callOnLoad(this.handleOffset);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleOffset);
    }

    defineOffset() {
      // console.log(this.offsetSrc.parentElement.style);
      this.style.setProperty('--image-offset', `${this.offsetSrc.offsetHeight * -1}px`);
    }
  }

  customElements.define('johnson-hartig', JohnsonHartig);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      document.querySelectorAll('video').forEach((video) => video.play());
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
      document.querySelectorAll('video').forEach((video) => video.play());
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-columns"] && !Shopify.designMode) return;
  try {
    
  class PageColumns extends HTMLElement {
    constructor() {
      super();

      this.mql = window.matchMedia('(min-width: 1900px)');
      this.dynamicColumns = this.checkDynamicColumns();
      this.handleAlignment = debounce(this.matchImageAlignment.bind(this), 100);
    }

    connectedCallback() {
      if (this.dynamicColumns) {
        this.fluidColumn = this.querySelector('.column--text-first');
        this.fluidImage = this.fluidColumn.querySelector('.column__image');
        this.staticColumn = this.querySelector('.column--image-first');
        this.staticImage = this.staticColumn.querySelector('.column__image');
        
        callOnLoad(this.handleAlignment);
        window.addEventListener('resize', this.handleAlignment);
      }
    }

    disconnectedCallback() {
      if (this.dynamicColumns) {
        window.removeEventListener('resize', this.handleAlignment);
      }
    }

    checkDynamicColumns() {
      return this.querySelector('.column--image-first') && this.querySelector('.column--text-first')
    }

    matchImageAlignment() {
      if (this.dynamicColumns) {
        if (this.mql.matches) {
          const fluidBottom = this.fluidImage.offsetTop + this.fluidImage.offsetHeight - this.fluidColumn.offsetTop;
          const staticBottom = this.staticImage.offsetHeight;
  
          if ((fluidBottom <= staticBottom) || this.fluidColumn.style.justifyContent != '') {
            this.fluidColumn.style.justifyContent = 'space-between';
            this.fluidColumn.style.height = `${staticBottom}px`;
          }
        } else {
          this.fluidColumn.style.justifyContent = '';
          this.fluidColumn.style.height = '';
        }
      }
    }
  }

  customElements.define('page-columns', PageColumns);

  } catch(e) { console.error(e); }
})();
})();
